import { combineReducers } from 'redux';

import { tipsConstants } from '../constants';
import { TipsStatus } from '../shared/types';
import { InfluencerWinData } from '../types';

export interface TipsModel {
  name: string;
  date: string;
  market: string;
  stockCode: string;
  direction: string;
  publicAlias: string;
  membership: string;
  price: number;
  channel?: string;
  sourceLink?: string;
  keyComment?: string;
  priceDate?: string;
  status?: TipsStatus;
}

interface loadInfluencerWinRatesState {
  loading: boolean;
  influencerRanks?: InfluencerWinData;
  influencerTips?: TipsModel[];
  error?: Error;
}
const loadInfluencerWinRates = (
  state: loadInfluencerWinRatesState = {
    loading: false,
    influencerRanks: null,
    influencerTips: null,
  },
  action
) => {
  switch (action.type) {
    case tipsConstants.LOAD_INFLUENCER_WIN_RATES_REQUEST: {
      return {
        ...state,
        influencerRanks: null,
        influencerTips: null,
        loading: true,
      };
    }

    case tipsConstants.LOAD_INFLUENCER_WIN_RATES_SUCCESS: {
      return {
        ...state,
        influencerRanks: action.influencerRanks,
        influencerTips: action.influencerTips,
        loading: false,
      };
    }

    case tipsConstants.LOAD_INFLUENCER_WIN_RATES_FAILURE: {
      return {
        ...state,
        influencerRanks: null,
        influencerTips: null,
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const stockExpertTips = (
  state = {
    loading: false,
    tips: undefined,
  },
  action
) => {
  switch (action.type) {
    case tipsConstants.FETCH_STOCK_EXPERT_TIPS_REQUEST: {
      return {
        loading: true,
      };
    }

    case tipsConstants.FETCH_STOCK_EXPERT_TIPS_SUCCESS: {
      return {
        tips: action.tips,
      };
    }

    case tipsConstants.FETCH_STOCK_EXPERT_TIPS_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  loadInfluencerWinRates,
  stockExpertTips,
});
